module.exports = __webpack_public_path__ + "assets/account.611caf6b.svg";